import { Stack } from '@mui/material'
import React from 'react'

import { ResponseAlertNotification } from 'components/status-checks/common/ResponseAlertNotification'
import { ResponseBodyField } from 'components/status-checks/common/ResponseBodyField'
import { ResponseCodeField } from 'components/status-checks/common/ResponseCodeField'
import { type AuthenticationResponse } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { isValidStatusCodeOrRange } from 'utils/team-external-integrations/team-external-integrations-util'

export const ObservabilityToolAuthenticationStatus: React.FC<{
  authenticationResponse: AuthenticationResponse
}> = ({ authenticationResponse }) => {
  const { alertSeverity, httpStatusCode, responseBody, message } =
    authenticationResponse

  if (!alertSeverity) return null

  const isBodyContentTypeHtml =
    authenticationResponse?.contentType?.includes('html')

  return (
    <Stack spacing={2}>
      <ResponseAlertNotification alertSeverity={alertSeverity}>
        {message}
      </ResponseAlertNotification>
      {!isValidStatusCodeOrRange(httpStatusCode) &&
        alertSeverity === 'error' && (
          <ResponseCodeField httpStatusCode={httpStatusCode} />
        )}
      {Boolean(responseBody) &&
        !isBodyContentTypeHtml &&
        alertSeverity === 'error' && (
          <ResponseBodyField responseBody={responseBody} />
        )}
    </Stack>
  )
}
